module.exports = __webpack_public_path__ + "static/media/img30.ce33beef.jpg";